export default {
  WithoutItemCard: {
    field: {
      title: 'Você ainda não tem nenhum talhão ativo',
      text: 'Todas os seus talhões aparecerão aqui.',
      create_field: 'Criar talhão',
    },
    sowing: {
      title: 'Você ainda não tem nenhuma semeadura ativa na safra atual',
      text: 'Todas as suas semeaduras da safra atual aparecerão aqui.',
      execute_sowing: 'Executar semeadura',
    },
    filter: {
      not_found_title: 'Não encontramos resultados',
      not_found_text: 'Tente mudar os filtros',
    },
    integrations: {
      title: 'Você ainda não tem nenhuma integração ativa',
      text: 'Todas as suas integrações aparecerão aqui.',
      add_integration: 'Adicione integração',
    },
  },
  FarmDisabled: {
    farm_disabled: 'Fazenda desabilitada',
    farm_disabled_message_banner_text1: 'Habilite a fazenda para registrar',
    farm_disabled_message_banner_text2:
      'Você só poderá registrar se sua fazenda estiver habilitada. Clique no botão abaixo para gerenciar fazendas.',
    manager_farms: 'Gerenciar fazendas',
  },
}
